"use client";

import { SafeHydrate } from "@/SafeHydrate";
import React from "react";
import { Calendar } from "lucide-react";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Skeleton } from "@/components/ui/skeleton";
import { AspectRatio } from "@/components/ui/aspect-ratio";
function BlogGridConsumer() {
  const {
    posts,
    loading,
    error
  } = usePosts();
  if (loading) {
    return <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
        {[...Array(6)].map((_, i) => <div key={i} data-index={i} className="flex flex-col gap-4">
            <AspectRatio ratio={3 / 4}>
              <Skeleton className="h-full w-full rounded-none" />
            </AspectRatio>
            <Skeleton className="h-6 w-3/4 rounded-none" />
            <Skeleton className="h-4 w-full rounded-none" />
            <Skeleton className="h-4 w-2/3 rounded-none" />
            <Skeleton className="h-4 w-1/4 rounded-none mt-2" />
          </div>)}
      </div>;
  }
  if (error) {
    return <div className="flex flex-col items-center justify-center py-12 text-center">
        <p className="text-muted-foreground mb-4">Unable to load stories at this time.</p>
      </div>;
  }
  if (posts.length === 0) {
    return <div className="flex flex-col items-center justify-center py-24 text-center border border-border bg-muted/10">
        <p className="text-muted-foreground font-serif text-xl">No stories from the road yet.</p>
        <p className="text-sm text-muted-foreground mt-2">Check back soon for new adventures.</p>
      </div>;
  }
  return <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
      {posts.map((post, i) => {
      const category = post.categories && post.categories.length > 0 ? post.categories[0].name : "Journey";
      return <article key={post.id} data-index={i} className="group flex flex-col">
            <Link to={post.link || "#"} className="block overflow-hidden mb-5 relative">
              <AspectRatio ratio={3 / 4}>
                {post.featuredImage ? <img src={post.featuredImage} alt={post.title} className="object-cover w-full h-full transition-all duration-700 ease-in-out group-hover:scale-105 group-hover:opacity-90" loading="lazy" /> : <div className="w-full h-full bg-muted flex items-center justify-center transition-all duration-700 ease-in-out group-hover:scale-105 group-hover:opacity-90">
                    <span className="text-muted-foreground font-serif">Frontier North</span>
                  </div>}
              </AspectRatio>
              <div className="absolute top-4 left-4 z-10">
                <Badge variant="secondary" className="rounded-none bg-background/90 text-foreground hover:bg-background backdrop-blur-sm border-none shadow-sm">
                  {category}
                </Badge>
              </div>
            </Link>
            
            <div className="flex flex-col flex-grow">
              <Link to={post.link || "#"} className="block group-hover:text-primary transition-colors">
                <h3 className="font-serif text-2xl font-medium leading-tight mb-3 text-foreground line-clamp-2">
                  {post.title}
                </h3>
              </Link>
              
              {post.excerpt && <div className="text-muted-foreground text-base mb-4 line-clamp-2 flex-grow" dangerouslySetInnerHTML={{
            __html: post.excerpt
          }} />}
              
              <div className="flex items-center text-sm text-muted-foreground mt-auto pt-2">
                <SafeHydrate><Calendar className="w-4 h-4 mr-2 opacity-70" /></SafeHydrate>
                <time dateTime={post.date}>{post.date || "Recent"}</time>
              </div>
            </div>
          </article>;
    })}
    </div>;
}
export default function StoriesFromTheRoad() {
  const wp_query_params = {
    post_type: "post",
    per_page: 6,
    status: "publish"
  };
  const wp_query = new WP_Query(wp_query_params);
  return;
}